export const denyUrls = [
  /graph\.facebook\.com/i, // Facebook flakiness
  /connect\.facebook\.net\/en_US\/all\.js/i, // Facebook blocked
  /eatdifferent\.com\.woopra-ns\.com/i, // Woopra flakiness
  /static\.woopra\.com\/js\/woopra\.js/i,
  /extensions\//i, // Chrome extensions
  /^chrome:\/\//i, // Other plugins
  /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
  /webappstoolbarba\.texthelp\.com\//i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
]

export const ignoreErrors = [
  // Random plugins/extensions
  'top.GLOBALS',
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  'originalCreateNotification',
  'canvas.contentDocument',
  'MyApp_RemoveAllHighlights',
  'http://tt.epicplay.com',
  "Can't find variable: ZiteReader",
  'jigsaw is not defined',
  'ComboSearch is not defined',
  'http://loading.retry.widdit.com/',
  'atomicFindClose',
  // Facebook borked
  'fb_xd_fragment',
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
  // reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268
  'bmi_SafeAddOnload',
  'EBCallBackMessageReceived',
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  'conduitPage',
  "Failed to read the 'localStorage'",
  'SecurityError: The operation is insecure',
  'jQuery is not defined',
  "Can't find variable: _AutofillCallbackHandler",
  'ChunkLoadError'
]
